import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import apiClient from "../apiClient";
import type { MembershipOrganization } from "../../utils/types";

export const authOrganizationKeys = {
  all: ["auth", "organizations"] as const,
};

export type SwitchOrgResponse = {
  access_token: string;
  token_type: string;
  org_id: number;
  mfa: string;
};

export const useAuthOrganizationsQuery = (enabled = true) =>
  useQuery({
    queryKey: authOrganizationKeys.all,
    queryFn: async () => {
      const { data } = await apiClient.get<MembershipOrganization[]>(
        "/auth/organizations",
      );
      return data;
    },
    enabled,
    staleTime: 60_000,
  });

export const useSwitchOrgMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (orgId: number) => {
      const { data } = await apiClient.post<SwitchOrgResponse>(
        "/auth/switch-org",
        { org_id: orgId },
      );
      return data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries();
    },
  });
};
